import { API_URL } from "./api";

export interface AutoDossierPayload {
  immatriculation?: string;
  vin?: string;
  brand?: string;
  model?: string;
  titre?: string;
  task_id_carte_grise?: string;
  task_id_identity?: string;
  cerfa_pdf_path?: string;
  cerfa_state?: any;
}

export async function createDossierFromCerfa(payload: AutoDossierPayload) {
  const res = await fetch(`${API_URL}/dossiers/auto-from-cerfa`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Erreur création dossier auto");
  return (await res.json()) as { id: number };
}
